export enum FilterView {
  CLIENTS_TABLE = 'CLIENTS_TABLE',
  FORMS_TABLE = 'FORMS_TABLE',
  MESSAGES_TABLE = 'MESSAGES_TABLE',
  TASKS_TABLE = 'TASKS_TABLE',
  USERS_TABLE = 'USERS_TABLE',
  GROUPS_TABLE = 'GROUPS_TABLE',
  ORGANIZATIONS_TABLE = 'ORGANIZATIONS_TABLE',
}

export interface FilterResponse {
  id: number;
  view: FilterView;
  name: string;
  data: string;
  ownerId: string;
  isDefault: boolean;
  isPinned: boolean;
}

export interface FilterRequest {
  view: FilterView;
  name: string;
  data: string;
  isDefault: boolean;
  isPinned: boolean;
}
